import * as React from "react";
import { Box, Grid, TextField } from "@mui/material";

export default function MultipleTextInputs({ question, onAnswer = () => {} }) {
  const numItems = question?.display?.initialState?.length || 0;
  const [selectedAnswer, setSelectedAnswer] = React.useState(
    new Array(numItems).fill("")
  );

  React.useEffect(() => {
    setSelectedAnswer(question?.display?.initialState || []);
  }, [question]);

  const containsLowercaseWord = (text) => text.includes("lowercase");

  const handleSetAnswer = (i, value) => {
    const newSelectedAnswer = [...selectedAnswer];
    const shouldBeLowercase = containsLowercaseWord(
      question?.questionText || ""
    );

    newSelectedAnswer[i] = shouldBeLowercase
      ? value.toLowerCase()
      : value.toUpperCase();
    setSelectedAnswer(newSelectedAnswer);

    const canProceed = newSelectedAnswer.every((ans) => ans.trim() !== "");
    
    // get the answer of the empty textboxes
    let submitAnswer = [];
    question?.display?.initialState.forEach((row, index) => {
        if (row === "")
            submitAnswer.push(newSelectedAnswer[index] || "");
    });

    onAnswer({
      canProceed,
      answer: submitAnswer,
    });
  };

  const rows = [];
  for (let i = 0; i < numItems; i += 6) {
    rows.push((question?.display?.initialState || []).slice(i, i + 6));
  }

  return (
    <React.Fragment>
      <Box className="choices-container" sx={{ px: 4, textAlign: "center" }}>
        {rows.map((row, rowIndex) => (
          <Grid container sx={{ mt: 2 }} key={rowIndex} alignItems="center">
            {row.map((item, i) => (
              <Grid item sm={2} xs={2} key={i} sx={{ px: 0.5 }}>
                <Box
                  sx={{ display: "flex", alignItems: "center", flex: 1 }}
                ></Box>
                <TextField
                  fullWidth
                  value={selectedAnswer[rowIndex * 6 + i]}
                  onChange={(e) =>
                    handleSetAnswer(rowIndex * 6 + i, e.target.value)
                  }
                  variant="outlined"
                  size="small"
                  disabled={item !== ""}
                  InputProps={{
                    style: { textAlign: "center" },
                  }}
                  inputProps={{
                    style: { textAlign: "center" },
                  }}
                />
              </Grid>
            ))}
          </Grid>
        ))}
      </Box>
    </React.Fragment>
  );
}
